import React from 'react'
import {Line} from '../utilline'
//
// 2025-0417 新設
// ●葬儀施設:会館/法要室/ホール/直葬
//
// 使う場所 以下の 備考欄を置き換える。memoフィールドを使う
// a) 法要室葬儀 '通夜H' 
// b) 安置(ミニホール) '通夜A' 
//
// 
export const FaciOption = ({line, readonly}: {line: Line; readonly: boolean;}) => {
  const [option, setOption] = React.useState(line.row.memo)
//  const [option, setOption] = React.useState( line.row.memo=== '' ? '会館': line.row.memo )
// なにも選択せずに予約した場合に 空 の row.memo を許す、齟齬がでるため。checkは必要かも。
  
  const handle = (e: React.ChangeEvent<HTMLInputElement>) => {
    line.row.memo = e.target.value //これ書き戻せたっけ？
    setOption(e.target.value)
  }
  //
  return (<>
  <div className="input-group">
    <label className="input-group-text">葬儀施設</label>

    {/* 会館 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='会館'} value={'会館'}
        disabled={readonly || false}
        onChange={handle}
      />
      <span className="ms-0">{'会館'}</span>
    </label>

    {/* 法要室 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='法要室'} value={'法要室'}
        disabled={readonly}
        onChange={handle}
      />
      <span className="ms-0">{'法要室'}</span>
    </label>

    {/* ホール */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='ホール'} value={'ホール'}
        disabled={ readonly}
        onChange={handle}
      />
      <span className="ms-0">{'ホール'}</span>
    </label>

    {/* 直葬 */}
    <label className="form-control input-group-text pointer">
      <input type="radio" className="form-check-input me-1"
        checked={option==='直葬'} value={'直葬'}
        disabled={readonly}
        onChange={handle}
      />
      <span className="ms-0">{'直葬'}</span>
    </label>
  </div>

  </>)
}
